import script from "./SigIssue.vue?vue&type=script&setup=true&lang=js"
export * from "./SigIssue.vue?vue&type=script&setup=true&lang=js"

import "./SigIssue.vue?vue&type=style&index=0&id=075acec2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-075acec2"]])

export default __exports__